import type { PerformanceDatapoint } from "owa-analytics";

export function isExecuting(datapoint: PerformanceDatapoint | undefined): datapoint is PerformanceDatapoint {
    return !!datapoint && !datapoint.hasEnded;
}
